<template>
  <div class="tests-page box is-shadowless">
    <!-- <guide-list /> -->
    <guides class="guides" />
  </div>
</template>

<script>
import Guides from "@/components/Guide/Guides";
// import GuideList from "@/components/Guide/GuideList";

export default {
  components: {
    Guides,
    // GuideList,
  },
};
</script>

<style>
.tests-page .guides {
  width: 1070px !important;
  margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Tests/index.vue